/*
 *   Copyright (c) 2023 
 *   All rights reserved.
 */
import React from "react";
import { ResponsiveHeatMap } from "@nivo/heatmap";

const VmoResponsiveHeatMap = (props) => {
  return <ResponsiveHeatMap {...props} />;
};

export default VmoResponsiveHeatMap;
